<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button defaultHref="/"></ion-back-button>
        </ion-buttons>
        <ion-title>Blog</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list>
        <ion-item button *ngFor="let post of posts" (click)="openLink(post.link)">
            <ion-label class="ion-text-wrap">
                {{ getTitle(post.title.rendered) }}
                <p>{{ post.date | date: 'longDate'}}</p>
            </ion-label>
        </ion-item>
    </ion-list>

</ion-content>
<ion-footer>
    <ion-toolbar>
        <ion-item lines="none">
            <ion-button (click)="openSocial('facebook')" fill="clear" slot="end">
                <ion-icon slot="icon-only" name="logo-facebook"></ion-icon>
            </ion-button>
            <ion-button (click)="openSocial('instagram')" fill="clear" slot="end">
                <ion-icon slot="icon-only" name="logo-instagram"></ion-icon>
            </ion-button>
            <ion-button (click)="openSocial('twitter')" fill="clear" slot="end">
                <ion-icon slot="icon-only" name="logo-twitter"></ion-icon>
            </ion-button>
        </ion-item>
    </ion-toolbar>
</ion-footer>